<template>
    <div>
        <PullContainer
            ref="pullContainerRef"
            :pullDownLoading="true"
            :pullDownLabel="true"
            @pullDownLoadingSuccess="pullDownLoadingSuccess"
        >
            <template #container>
                <div class="public_container">
                    <div class="returnNavBar">
                        <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="true"></ReturnNavBar>
                    </div>
                    <div class="top_search">
                        <van-search
                            v-model="searchForm.keyword"
                            placeholder="请输入查询内容"
                            @search="onSearch"
                            @clear="onSearch"
                        >
                            <template #right-icon>
                                <i class="iconfont icon-shaixuan" @click="handleClickAdvancedFilter"></i>
                            </template>
                        </van-search>
                    </div>
                    <div class="list_content_title">
                        <span>已选{{ selectedList.length }}条</span>
                        <div class="list_content_title_right">
                            全选<i
                                class="custom_checkbox"
                                :class="{ active: isCheckAll }"
                                @click="handleClickCheckAll"
                            ></i>
                        </div>
                    </div>
                    <div class="mobile_container payable_management_container">
                        <div class="mobile_container_list">
                            <ul v-infinite-scroll="onLoadList">
                                <li class="payable_list_item" v-for="(row, index) in tableData" :key="index">
                                    <div class="payable_list_item_left">
                                        <div class="payable_list_item_top">
                                            <div class="mobile_list_head_user">
                                                <img
                                                    :src="row.uid_info.avatar ? row.uid_info.avatar : defaultImg"
                                                    alt=""
                                                />
                                                <span class="ellipsis">{{ row.uid_info && row.uid_info.name }}</span>
                                            </div>
                                            <span>{{ row.created_at }}</span>
                                        </div>
                                        <div class="payable_list_item_content">
                                            <p>
                                                <span class="link-label" @click="handleClickDetail(row)">{{
                                                    row.receivable_no
                                                }}</span>
                                            </p>
                                            <p v-if="row.source_type == 'order'">
                                                {{ row.payment_company_name || "--" }}
                                            </p>
                                            <p v-else>{{ row.supplier_name || "--" }}</p>
                                        </div>
                                    </div>
                                    <div class="list_item_checkbox">
                                        <van-checkbox
                                            v-model="row.checked"
                                            shape="square"
                                            @change="handleClickChangeSelect(row)"
                                        ></van-checkbox>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <BatchOperateBar
                        :operateBarList="operateBarList"
                        @handleClickOperateType="handleClickOperateType"
                    />
                    <!-- 批量驳回 -->
                    <van-overlay :custom-style="{ background: 'rgba(0, 0, 0, 0.3)' }" :show="rejectDialog">
                        <div class="custom_overlay_content">
                            <div class="custom_overlay_content_title">
                                <span>驳回原因</span>
                                <van-icon name="cross" @click="handleClickRejectClose" />
                            </div>
                            <div class="custom_overlay_content_form">
                                <van-field
                                    v-model="reject_reason"
                                    rows="6"
                                    autosize
                                    label=""
                                    type="textarea"
                                    maxlength="200"
                                    placeholder="请输入驳回原因"
                                />
                                <van-button color="#2990FF" @click="handleClickRejectConfirm">确定</van-button>
                            </div>
                        </div>
                    </van-overlay>
                </div>
            </template>
        </PullContainer>
        <ListAdvancedFiltering
            v-if="searchPopupShow"
            ref="listAdvancedFiltering"
            :system_fields.sync="systemFilterFields"
            @sendFilterData="getFilterData"
        />
    </div>
</template>
<script>
import { ReceivableList, ReceivableBatchReject } from "@/api";
import { pagination } from "@/mixins";
import { mapState } from "vuex";
import PullContainer from "@/components/mComponents/PullContainer.vue";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import BatchOperateBar from "../component/batch_operate_bar.vue";
import ListAdvancedFiltering from "../component/ListAdvancedFiltering.vue";
export default {
    name: "ReceivableChoose",
    components: { PullContainer, ReturnNavBar, BatchOperateBar , ListAdvancedFiltering},
    data() {
        return {
            loading: false,
            source_id: "",
            source_type: "", // 采购退款应收=purchase_refund，订单回款应收=order
            payment_status: "",
            defaultImg: require("@/assets/images/default.jpg"),
            searchForm: {
                keyword: "",
            },
            tableData: [],
            isCheckAll: false, // 是否全选
            selectedList: [],
            // 批量驳回
            rejectDialog: false,
            reject_reason: "",

            custom_filter: {}, // 高级筛选确认条件
        };
    },
    mixins: [pagination],
    computed: {
        operateBarList() {
            if (this.source_type === "order") {
                return [
                    { icon: "icon-fenpei", title: "批量驳回", type: "batch_reject" },
                    { icon: "icon-hebingkehu", title: "批量确认", type: "batch_confirm" },
                ];
            } else {
                return [{ icon: "icon-hebingkehu", title: "批量确认", type: "batch_confirm" }];
            }
        },
        ...mapState(["searchPopupShow"]),
        systemFilterFields() {
            return [
                {
                    field_type: "contact",
                    field_key: "uid",
                    is_system: 1,
                    field_name: "申请人",
                    system_type: "system",
                    field_value_type: "int",
                },
                {
                    field_type: "date_range",
                    field_key: "apply_time_range",
                    is_system: 1,
                    field_name: "创建时间",
                    system_type: "system",
                    field_value_type: "array",
                },
            ];
        },
    },
    created() {
        if (this.$route.query) {
            this.source_type = this.$route.query.source_type;
            this.payment_status = this.$route.query.payment_status;
            this.onSearch();
        }
    },
    methods: {
        pullDownLoadingSuccess(flag) {
            if (flag) {
                this.pullDownLoading = true;
                this.onSearch();
            }
        },
        getStatusName(status) {
            let label = "";
            status = String(status);
            switch (status) {
                case "1":
                    label = "待付款";
                    break;
                case "2":
                    label = "已付款";
                    break;
                case "3":
                    label = "已取消";
                    break;
                case "4":
                    label = "部分付款";
                    break;
            }
            return label;
        },
        // 全选框改变
        handleClickCheckAll() {
            this.isCheckAll = !this.isCheckAll;
            this.tableData.forEach((item) => {
                this.$set(item, "checked", this.isCheckAll);
            });
        },
        // 复选框状态改变
        handleClickChangeSelect(item) {
            if (item.checked) {
                this.selectedList.push(item);
            } else {
                const index = this.selectedList.findIndex((list) => list.payable_no == item.payable_no);
                this.selectedList.splice(index, 1);
            }
            if (this.selectedList.length < this.tableData.length) {
                this.isCheckAll = false;
            } else {
                this.isCheckAll = true;
            }
        },
        // 详情
        handleClickDetail(row) {
            this.$router.push({
                name: "PayableDetails",
                query: {
                    payable_no: row.payable_no,
                },
            });
        },
        // 点击高级筛选
        handleClickAdvancedFilter() {
            this.$store.dispatch("searchPopupShow", true);
        },
        // 获取高级筛选数据
        getFilterData(data) {
            this.custom_filter = data;
            this.$store.dispatch("searchPopupShow", false);
            this.onSearch();
        },
        // 批量操作确认类型
        handleClickOperateType(type) {
            if (!this.selectedList.length || this.selectedList.length < 2) return this.$toast("请至少选择两个应收单");
            switch (type) {
                case "batch_reject":
                    // 批量驳回
                    if (!this.selectedList.length) return this.$toast("请选择需要驳回的应收单");
                    this.rejectDialog = true;
                    break;
                case "batch_confirm":
                    // 批量确认
                    this.$router.push({
                        name: "PaymentConfirmation",
                        query: {
                            receivable_no: this.selectedList.map((item) => item.receivable_no),
                            type: "batch_confirm",
                            source_type: this.source_type,
                        },
                    });
                    break;
            }
        },
        // 驳回弹框关闭
        handleClickRejectClose() {
            this.reject_reason = "";
            this.rejectDialog = false;
        },
        // 驳回确认
        handleClickRejectConfirm() {
            if (!this.reject_reason) return this.$toast("请填写驳回原因");
            ReceivableBatchReject({
                receivable_nos: this.selectedList.map((item) => item.receivable_no),
                reject_reason: this.reject_reason,
            }).then((res) => {
                if (res.code == 200) {
                    this.$toast({
                        message: res.message,
                        type: "success",
                        duration: 1000,
                        onClose: () => {
                            this.handleClickRejectClose();
                            this.onSearch();
                        },
                    });
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        onSearch() {
            this.pagination.pageNum = 1;
            this.tableData = [];
            this.getTableData();
        },
        // 加载更多
        onLoadList() {
            if (this.pagination.total == this.tableData.length) {
                return false;
            }
            if (this.loading == false) {
                this.getTableData();
            }
        },
        getTableData() {
            this.loading = true;
            let params = {
                source_type: this.source_type,
                status: this.payment_status,
                page: this.pagination.pageNum,
                pageSize: 10, // this.pagination.pageSize
                keyword: this.searchForm.keyword,
            };
            if (this.custom_filter.custom_field && this.custom_filter.custom_field.length) {
                this.custom_filter.custom_field.forEach((option) => {
                    params[option.field_key] =
                        option.field_value_type == "int" ? option.field_value[0] : option.field_value;
                });
            }
            ReceivableList(params)
                .then((res) => {
                    if (res.code == 200) {
                        const { data, total } = res.data;
                        this.tableData = this.tableData.concat(data);
                        this.pagination.total = total;
                        this.pagination.pageNum++;
                        this.loading = false;
                        if (this.pullDownLoading) {
                            this.pullDownLoading = false;
                            this.$refs.pullContainerRef.pullDownLoadingEnd("刷新成功");
                        }
                    }
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
    },
};
</script>
<style lang="scss" scoped>
.list_content_title {
    height: 45px;
    padding: 0 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid rgb(247, 248, 250);
    & > span {
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 22px;
        color: rgba(153, 153, 153, 1);
    }
    .list_content_title_right {
        display: flex;
        gap: 8px;
        line-height: 18px;
        color: rgba(153, 153, 153, 1);
        .custom_checkbox {
            display: block;
            width: 16px;
            height: 16px;
            opacity: 1;
            border-radius: 2px;
            border: 1px solid rgba(153, 153, 153, 1);
            position: relative;
            &::after {
                content: "";
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 8px;
                height: 8px;
                opacity: 1;
                border-radius: 1px;
                border: 1px solid rgba(153, 153, 153, 1);
            }
            &.active {
                border-color: rgba(41, 144, 255, 1);
                &::after {
                    background-color: rgba(41, 144, 255, 1);
                    border-color: rgba(41, 144, 255, 1);
                }
            }
        }
    }
}
.payable_management_container {
    .mobile_container_list {
        padding: 0 16px 50px 16px;
        .payable_list_item {
            width: 100%;
            margin-bottom: 8px;
            display: flex;
            .payable_list_item_left {
                padding: 12px;
                border-radius: 6px;
                background: rgba(255, 255, 255, 1);
                flex: 1;
            }
            .list_item_checkbox {
                height: 100%;
                padding-left: 16px;
                ::v-deep {
                    .van-checkbox__icon {
                        font-size: 16px;

                        .van-icon {
                            border-color: rgba(217, 217, 217, 1);
                            border-radius: 4px;
                            background-color: rgba(255, 255, 255, 1);
                        }
                    }

                    .van-checkbox__icon--checked {
                        .van-icon {
                            border-color: rgba(41, 144, 255, 1);
                            background-color: rgba(41, 144, 255, 1);
                        }
                    }
                }
            }
            .payable_list_item_top {
                padding-bottom: 10px;
                display: flex;
                align-items: center;
                position: relative;
                & > span {
                    font-size: 12px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 18px;
                    color: rgba(153, 153, 153, 1);
                }
                .link-label {
                    color: rgba(41, 144, 255, 1);
                }
            }
            .payable_list_item_content {
                p {
                    font-size: 12px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 18px;
                    color: rgba(102, 102, 102, 1);
                    & + p {
                        margin-top: 4px;
                    }
                    .link-label {
                        color: rgba(41, 144, 255, 1);
                    }
                }
            }
        }
    }
}
</style>
